import { RootState } from "../../../../store";
import { commitmentsSliceSelector } from "../../commitmentsSliceSelector";

export const utilizationAndCoverageChartTypeSelector = (state: RootState) => {
  const slice = commitmentsSliceSelector(state);

  return slice.coverageAndUtilization.chartType;
};
